import React, { useEffect } from "react";
import SVG from "../SVG/SVG";
import "./AttendanceListCard.scss";
import { ACardItem } from "./AttendanceListCard.types";
import ACardProps from "./AttendanceListCard.types";

const AttendanceListCard = ({ AcardList }: ACardProps) => {
  const [list, setList] = React.useState(AcardList);
  const [hideEdit, setHideEdit] = React.useState(true);
  // console.log(list);
  let separator = " ";
  const showEdit = () => {
    setHideEdit(!hideEdit);
    console.log(hideEdit);
  };

  useEffect(() => {
    setList(AcardList);
  }, [AcardList]);

  return (
    <>
      <div>
        {list &&
          list.map(
            ({ cardType, shiftType, Data }: ACardItem, index: number) => (
              <div className="list-container-card" key={index}>
                {/* attendance list card  */}
                {cardType == "attendanceListCard" && (
                  <div className="card">
                    <div className="list-container">
                      <div className="w-100">
                        <div className="flex-container jc-sb">
                          <div className="flex">
                            <SVG
                              type={shiftType === "day" ? "morning" : "night"}
                              isActive={true}
                            ></SVG>
                            <div className="flex-container">
                              <div className="gray-color fw-400 fs-12">
                                &nbsp;{Data.shiftName}:{" "}
                              </div>
                              <div className="fw-500 fs-13">
                                &nbsp;
                                {Data.shiftDate}
                              </div>
                            </div>
                          </div>
                          <div
                            className={`fs-12 fw-600 ${
                              Data.selfMarked === "PRESENT"
                                ? "green"
                                : Data.selfMarked === "ABSENT"
                                ? "red"
                                : "red"
                            }
                            }`}
                          >
                            {Data.selfMarked ? Data.selfMarked : ""}
                          </div>
                        </div>
                        <div className="flex-container">
                          <SVG type="time" isActive={true}></SVG>
                          <div className="flex-container">
                            <div className="gray-color fw-400 fs-12">
                              &nbsp;Login Time:{" "}
                            </div>
                            <div className="fw-500 fs-13">
                              &nbsp; {Data.loginTime}
                            </div>
                          </div>{" "}
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <div className="flex-container">
                            <div className="gray-color fw-400 fs-12">
                              Logout Time:{" "}
                            </div>
                            <div className="fw-500 fs-13">
                              &nbsp; {Data.logoutTime}
                            </div>
                          </div>
                        </div>
                        <div className="flex-container">
                          <SVG
                            type="location"
                            className="m-w-24"
                            isActive={true}
                          ></SVG>
                          <div className="flex-container">
                            <div className="gray-color fw-400 fs-12">
                              &nbsp;Location:
                            </div>
                            <div className="fw-500 fs-13">
                              &nbsp; {Data.Location}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )
          )}
      </div>
    </>
  );
};

export default AttendanceListCard;
